import { gql } from '@apollo/client';

export const USER_FIELDS = gql`
  fragment UserFields on UserNode {
    id
    activeRole
    username
    firstName
    middleName
    lastName
    email
    roles
    phone
    methodistGroupsCount
    pendingSurveysCount
    # ТЗ 0074: счётчик у «Moje faktury» и поп-ап при входе. 0 у не-студента.
    unpaidInvoicesCount
    overdueInvoicesCount
    # ТЗ 0074: приостановка доступа. Поле reason (внутренняя заметка сотрудника)
    # сюда НЕ запрашивается — студенту её не показываем, сервер отдаёт null.
    lmsAccessBlock {
      isBlocked
      blockedAt
      amountsDue {
        amount
        currency
      }
    }
    student {
      groupsCount
    }
    teacher {
      photo
      groupsCount
    }
  }
`;
